import { useAssessment } from '../../context/AssessmentContext'
import Shell from '../ui/Shell'
import { pulse } from '../ui/LightField'
import { AREA_BY_SLUG, BARC10_QUESTIONS, BARC10_LIKERT, HEADERS } from '../../data/onboarding'
import { getProgress, STEP_LABEL } from '../../lib/flow'

/**
 * BARC-10 recovery capital, asked when the PRIMARY area is in recovery — the
 * production rule. Seven-point agreement scale, one question per screen.
 */
function Barc10Step() {
  const { state, dispatch } = useAssessment()
  const index = state.currentBarcIndex
  const question = BARC10_QUESTIONS[index]
  const area = AREA_BY_SLUG[state.primaryAddiction]
  const noun = area?.noun ?? 'this'

  if (!question) {
    dispatch({ type: 'SET_SCREEN', payload: 'addictionSelection' })
    return null
  }

  const answer = (value, el) => {
    if (el) {
      const r = el.getBoundingClientRect()
      pulse(0.55, { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + r.height / 2) / window.innerHeight })
    }
    dispatch({ type: 'ANSWER_BARC', payload: { id: question.id, value } })
    window.setTimeout(() => {
      if (index < BARC10_QUESTIONS.length - 1) dispatch({ type: 'NEXT_BARC' })
      else dispatch({ type: 'SET_SCREEN', payload: 'dassAssessment' })
    }, 200)
  }

  const back = () => {
    if (index > 0) dispatch({ type: 'PREV_BARC' })
    else if (state.selectedAddictions.length > 1) dispatch({ type: 'SET_SCREEN', payload: 'prioritization' })
    else {
      dispatch({ type: 'SET_AREA_INDEX', payload: 0 })
      dispatch({ type: 'SET_SCREEN', payload: 'recoveryGate' })
    }
  }

  const current = state.barc10Answers[question.id]

  return (
    <Shell label={STEP_LABEL.barc10} progress={getProgress(state)} onBack={back}>
      <main className="flow">
        <div className="q" key={question.id}>
          <div className="q__meta">
            <span>{index + 1} of {BARC10_QUESTIONS.length}</span>
            <span>Recovery capital</span>
          </div>
          <div className="q__body">
            <p className="q__frame">{HEADERS.barc10}</p>
            <h1 className="q__text" style={{ marginTop: 8 }}>
              {question.text.replace('{{addiction}}', noun)}
            </h1>
          </div>
          <div className="q__body likert" style={{ animationDelay: '40ms' }} role="radiogroup" aria-label="How much do you agree">
            {BARC10_LIKERT.map((label, value) => (
              <button
                key={label}
                type="button"
                role="radio"
                aria-checked={current === value}
                className="likert__btn"
                onClick={(e) => answer(value, e.currentTarget)}
              >
                <span className="likert__dot" aria-hidden="true" />
                <span className="likert__label">{label}</span>
              </button>
            ))}
          </div>
        </div>
      </main>
    </Shell>
  )
}

export default Barc10Step
